module.exports = __webpack_public_path__ + "static/media/3동물권-생태통로.144b0560.mp3";